import cn from "classnames";
import styles from "../../screens/Auth/SignUp/Form/Form.module.sass";
import Icon from "../../components/Icon";
import React from "react";
import {useGoogleLogin} from "@react-oauth/google";

const Google = ({onSuccess, onError}) => {
    /**
     * Google Auth
     * @type {(overrideConfig?: OverridableTokenClientConfig) => void}
     */
    const googleLogin = useGoogleLogin({
        onSuccess: onSuccess,
        onError: onError,
        //flow: 'auth-code',
    });

    return (
        <button
            type='button'
            className={cn("icon", styles.icon)}
            onClick={() => googleLogin()}
        >
            <Icon name="google" size="16" />
            {/* <span>Google</span> */}
        </button>
    );
}

export default Google;